import React from "react";
import { DataTable } from "./DataTable";
import { Button, message } from "antd";
import { usePromptModel } from "../promptModel";
import { YhBox } from "../../../../components2/YhBox";

export const DataBox = () => {
    const { setIPromptDrawer, selectedRowKeys } = usePromptModel();

    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (!selectedRowKeys.length) {
                    message.warning("请选择你要操作的数据");
                    return;
                }
                setIPromptDrawer("addPeer");
            }}
        >增加同级</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (!selectedRowKeys.length) {
                    message.warning("请选择你要操作的数据");
                    return;
                }
                setIPromptDrawer("addSon");
            }}
        >增加下级</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (!selectedRowKeys.length) {
                    message.warning("请选择你要操作的数据");
                    return;
                }
                setIPromptDrawer("edit");
            }}
        >编辑</Button>
    </>;

    return (
        <YhBox action={action} title={'错误日志'}>
            <DataTable />
        </YhBox>
    )
}